export default "__VITE_PUBLIC_ASSET__8c7d1d4b__"